import React from 'react';
import Message from '../../../components/message/Message';
import { contentMessage } from '../../../helpers/contentMessage';
import Pagination from '../../../components/pagination/Pagination';
import { formatTime, formatDate } from '../../../helpers/helpers';

const Table = (props) => {
  // TABLE
  const { data, handleToggle } = props;
  // PAGINATION
  const { pagination } = props;

  return (
    <>
      {data && data.length > 0 ? (
        <>
          <table className="table">
            <thead className="thead">
              <tr>
                <th>Naziv Aktivnosti</th>
                <th>Ime Zaposlenog (Email)</th>
                <th>Datum</th>
                <th>Vreme</th>
                <th>Podaci</th>
              </tr>
            </thead>

            <tbody className="tbody">
              {data && data.length > 0 ? (
                data.map((item) => {
                  const employee = Object.values(item.employee) && Object.values(item.employee)[0];

                  return (
                    <tr key={item._id}>
                      <td>{item.description}</td>
                      <td>
                        <span>
                          {!!employee && employee.firstName} {!!employee && employee.lastName}
                        </span>
                        <span className="d-block mb-1" />
                        <span>
                          (
                          <a href={`mailto:${employee && employee.email}`} className="link">
                            {employee && employee.email}
                          </a>
                          )
                        </span>
                      </td>
                      <td>{formatDate(item)}</td>
                      <td>{formatTime(item)}</td>
                      <td>
                        <button type="button" className="btn btn-download" onClick={() => handleToggle({ name: 'download', data: item._id })}>
                          <span className="icon">
                            <img alt="Download" src="/assets/icons/download.svg" />
                          </span>
                          <span className="text">Preuzmi podatke</span>
                        </button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={5} style={{ backgroundColor: '#fff', height: '200px', border: '0' }}>
                    <h2 style={{ color: '#666', textAlign: 'center' }}>Data not found!</h2>
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <Pagination {...pagination} />
        </>
      ) : (
        <Message className="content-message">
          <h2 style={{ color: '#666' }}>{contentMessage.dataNotFound}</h2>
        </Message>
      )}
    </>
  );
};

export default Table;
